var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paga_con_credito && _vm.cuotas.length)?_c('b-input-group',{staticClass:"cont-payment-methods m-t-5 m-b-15",attrs:{"prepend":"Cuotas"}},[_c('b-form-select',{attrs:{"options":_vm.cuotas_options},model:{value:(_vm.cuota_id),callback:function ($$v) {_vm.cuota_id=$$v},expression:"cuota_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }